<template>
    <div id="margin-dialog-body">
        <v-dialog v-model="dialogConfirmacao" max-width="500">
            <v-card>
                <v-card-title class="headline primary--text"
                    >Deseja realmente modificar o título?</v-card-title
                >

                <v-card-text v-show="!dialogResponse"
                    >Esta modificação é definitiva e automaticamente
                    disponibilizará o título para protesto!</v-card-text
                >
                <v-card-text v-show="dialogResponse"
                    >Título modificado com sucesso!</v-card-text
                >

                <v-card-actions>
                    <v-spacer></v-spacer>

                    <v-btn
                        data-cy="simCorrecao"
                        color="green darken-1"
                        text
                        v-show="!dialogResponse"
                        @click="correcaoTitulo"
                        >Sim</v-btn
                    >

                    <v-btn
                        color="red darken-1"
                        text
                        v-show="!dialogResponse"
                        @click="fechaConfirmacao"
                        >Não</v-btn
                    >

                    <v-btn
                        color="green darken-1"
                        text
                        v-show="dialogResponse"
                        @click="fechaConfirmacao"
                        >Ok!</v-btn
                    >
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog
            persistent
            transition="dialog-bottom-transition"
            v-model="loading"
            width="450px"
        >
            <div class="text-center" width="420px">
                <v-card>
                    <v-progress-circular
                        class="ma-12"
                        indeterminate
                        size="150"
                        color="primary"
                        >Carregando...</v-progress-circular
                    >
                </v-card>
            </div>
        </v-dialog>

        <v-card max-width="900px" elevation="12">
            <v-toolbar class="mb-5" flat dark color="primary">
                <v-btn icon dark @click="fechaConfirmacao">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
                <v-toolbar-title>Correção de Título em Revisão</v-toolbar-title>
            </v-toolbar>
            <div class="ma-3">
                <v-card v-show="ativaCardNome" class="pa-2 mb-4">
                    <v-card-title class="mt-n4 primary--text"
                        >Nome</v-card-title
                    >
                    <v-text-field
                        outlined
                        dense
                        v-model="tituloLocal.nm_devedor"
                        label="Nome Devedor Atual"
                        readonly
                    ></v-text-field>
                    <v-text-field
                        data-cy="nomeAbreviado"
                        outlined
                        dense
                        v-model="tituloLocal.nm_devedor_cra"
                        label="Nome Devedor Abreviado"
                        :counter="45"
                        :rules="[validadorNome.required, validadorNome.min]"
                    ></v-text-field>
                </v-card>
                <v-card v-show="ativaCardEndereco" class="pa-2">
                    <v-card-title class="mt-n4 primary--text"
                        >Endereço</v-card-title
                    >
                    <v-text-field
                        outlined
                        dense
                        v-model="tituloLocal.ds_endereco_devedor"
                        label="Endereço Devedor Atual"
                        readonly
                    ></v-text-field>
                    <v-text-field
                        data-cy="enderecoAbreviado"
                        outlined
                        dense
                        v-model="tituloLocal.ds_endereco_devedor_cra"
                        label="Endereço Devedor Abreviado"
                        :counter="45"
                        :rules="[validadorNome.required, validadorNome.min]"
                    ></v-text-field>
                </v-card>
                <v-row class="ma-0">
                    <v-col>
                        <span class="text-grey">
                            * Campo de Nome e Campo de Endereço do Devedor pode
                            ter apenas 45 caracteres
                        </span>
                        <br />
                        <span class="text-grey">
                            * Campo de Endereço deve constar o número, se não,
                            colocar: s/n
                        </span>
                    </v-col>
                </v-row>
                <v-row class="pa-4 mt-0" justify="end">
                    <v-btn
                        @click="fechaConfirmacao"
                        class="ml-5"
                        dense
                        color="error"
                    >
                        Cancelar
                        <v-icon class="ml-2">cancel</v-icon>
                    </v-btn>
                    <v-btn
                        :disabled="desabilitarConfirmacao()"
                        data-cy="confirmarCorrecao"
                        @click="correcaoConfirmacao"
                        class="ml-5"
                        dense
                        color="success"
                    >
                        Confirmar
                        <v-icon class="ml-2">done</v-icon>
                    </v-btn>
                </v-row>
            </div>
        </v-card>
    </div>
</template>

<script>
import TituloService from '@/services/TituloService';
import { eventFecharModal } from '../helpers/Utilitarios';
import Vue from 'vue';

export default {
    name: 'DetalheTituloRevisao',
    props: {
        titulo: {
            type: Object,
            required: true
        }
    },
    watch: {
        titulo: {
            immediate: true,
            deep: true,
            handler(newVal) {
                if (newVal) {
                    this.tituloLocal = JSON.parse(JSON.stringify(newVal));
                    this.verificaRevisao();
                }
            }
        }
    },
    data() {
        return {
            tituloLocal: {},
            loading: false,
            disable: false,
            dialogResponse: false,
            dialogConfirmacao: false,
            ativaCardNome: true,
            ativaCardEndereco: true,
            validadorNome: {
                required: value => !!value || 'Requerido.',
                min: v => !v || v.length <= 45 || 'Reduza até 45 caracteres!'
            }
        };
    },
    mounted() {
        this.tituloLocal = JSON.parse(JSON.stringify(this.titulo));
        document.addEventListener('keyup', this.eventFecharModal);
        this.verificaRevisao();
    },
    beforeDestroy() {
        document.removeEventListener('keyup', this.eventFecharModal);
    },
    methods: {
        eventFecharModal,
        validarTamanhoString(string) {
            return (
                !this.tituloLocal[string] ||
                !this.tituloLocal[string].length ||
                this.tituloLocal[string].length > 45
            );
        },
        desabilitarConfirmacao() {
            if (this.ativaCardEndereco && this.ativaCardNome) {
                return (
                    this.validarTamanhoString('ds_endereco_devedor_cra') ||
                    this.validarTamanhoString('nm_devedor_cra')
                );
            }
            if (this.ativaCardEndereco) {
                return this.validarTamanhoString('ds_endereco_devedor_cra');
            }
            if (this.ativaCardNome) {
                return this.validarTamanhoString('nm_devedor_cra');
            }
            return true;
        },
        verificaRevisao() {
            this.ativaCardEndereco = true;
            this.ativaCardNome = true;
            if (this.tituloLocal.ds_revisao === '[ND]') {
                this.ativaCardEndereco = false;
            }
            if (this.tituloLocal.ds_revisao === '[ED]') {
                this.ativaCardNome = false;
            }
        },
        fechaConfirmacao() {
            this.dialogConfirmacao = false;
            this.$emit('fecharModal');
        },
        correcaoConfirmacao() {
            this.dialogConfirmacao = true;
            this.dialogResponse = false;
        },
        correcaoTitulo() {
            this.dialogConfirmacao = false;
            this.loading = true;
            let service = new TituloService(Vue.http, this.$store);
            service
                .corrigeTitulo(
                    this.tituloLocal.id_titulo,
                    this.tituloLocal.nm_devedor_cra,
                    this.tituloLocal.ds_endereco_devedor_cra,
                    this.tituloLocal.cd_status
                )
                .then(
                    () => {
                        this.loading = false;
                        this.disable = true;
                        this.$emit('fecharModal', true);
                    },
                    error => {
                        console.error('Error correcting title:', error);
                        this.loading = false;
                        this.disable = true;
                        this.$emit('fecharModal', false);
                    }
                );
        }
    }
};
</script>
<style scoped>
.text-grey {
    color: #9e9e9e;
    font-size: small;
}

#margin-dialog-body {
    width: 100%;
    background-color: white;
    border-radius: 4px;
}
</style>
